import { Component, ViewChild, Output,EventEmitter } from '@angular/core'
import { DocumentService } from 'app/services/document.service'
import { FilesService } from 'app/services/files.service'
import { ModalPanelComponent } from 'app/shared/components/modal-panel/modal-panel.component'
import { LoaderComponent } from 'app/shared/components/loader/loader.component'
import { SharepointFile } from '../../../models/sharepoint-data'
import { FileType } from '../../../models/file-type.enum'
import { Source } from '../../../models/source.enum'
import { SharepointService } from '../../../services/sharepoint.service'
import { CompetitionService } from '../../../services/competition.service'
import { PictureParkService } from '../../../services/picture-park.service'
import { BsModalService } from 'ngx-bootstrap/modal'

@Component({
  selector: 'app-modal-add-document',
  templateUrl: './modal-add-document.component.html',
  styleUrls: ['./modal-add-document.component.scss']
})
export class ModalAddDocumentComponent {
  @Output() close = new EventEmitter()
  @ViewChild('modalPanel') modalPanel: ModalPanelComponent

  uploadFileBlob: Blob
  uploadFile: File
  url: string
  name: string
  size: number
  publicationDate: number

  constructor(
    private sharepointService: SharepointService,
    private modalService: BsModalService,
    private competitionService: CompetitionService,
    private pictureParkService: PictureParkService,
    private documentService: DocumentService
  ) { }

  onSelectFile(event: any) {
    const reader = new FileReader()
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0]
      this.uploadFile = file
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.uploadFileBlob = file
        this.url = file.name
        this.name = file.name
        this.size= file.size
      }
    }
  }

  onAddDocument(): void {
    if (this.uploadFileBlob.type.indexOf('pdf') !== -1 || this.uploadFileBlob.type.indexOf('image') !== -1) {
      const sharepointDoc: SharepointFile = {
        name: this.name,
        mimeType: this.uploadFileBlob.type,
        contentType: this.uploadFileBlob.type.indexOf('pdf') !== -1 ? FileType.Doc : FileType.Img,
        displayName: this.name,
        source: Source.Document,
        publicationDate: this.publicationDate,
        updateDate: new Date().getTime(),
        size: this.uploadFileBlob.size
      }

      this.sharepointService.uploadSharepoint(sharepointDoc, this.uploadFileBlob).subscribe({
        next: () => {
          this.close.emit()
          this.modalPanel.onClose()
        }
      })
    }

    if (this.uploadFileBlob.type.indexOf('video') !== -1) {
      let loaderRef = this.modalService.show(LoaderComponent, {
        class: 'modal-lg',
        backdrop: 'static'
      })
      const document = {
        parentId: this.competitionService.getCompetitionId(),
        name: this.name,
        mimeType: this.uploadFileBlob.type,
        contentType: FileType.Video,
        displayName: this.name,
        source: Source.Document,
        publicationDate: this.publicationDate,
        updateDate: new Date().getTime(),
        createdTime: new Date().getTime(),
        size: this.uploadFileBlob.size
      };
      
      // Store loader reference globally so PictureParkService can hide it when done
      (window as any).uploadLoaderRef = loaderRef
      
      this.pictureParkService.initializeFileUpload(this.uploadFileBlob, document)

      // Don't hide loader immediately - let PictureParkService hide it when upload completes
      this.close.emit()
      this.modalPanel.onClose()
    }
  }

  get isVideoFile() {
    return this.uploadFile && this.uploadFile.type.indexOf('video') !== -1
  }

  removeFile() {
    this.uploadFile = null
    this.uploadFileBlob = null
    this.size = null
    this.name = null
    this.url = null
  }
}
